import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import DashboardLayout from '../components/layout/DashboardLayout';
import { Input } from '../components/ui/input';
import {
  Smartphone, Tv, CreditCard, Zap, Car, Banknote,
  Flame, Wind, Shield, Gamepad2, FileText, Heart,
  Search, Home, ChevronRight, Lock,
} from 'lucide-react';

const SERVICES = [
  { id: 'mobile', name: 'MOBILE RECHARGE', icon: Smartphone, color: '#f97316', bg: '#fff7ed', path: '/recharge', active: true },
  { id: 'dth', name: 'DTH RECHARGE', icon: Tv, color: '#3b82f6', bg: '#eff6ff', path: '/recharge?type=dth', active: true },
  { id: 'electricity', name: 'ELECTRIC BILL PAYMENT', icon: Zap, color: '#eab308', bg: '#fefce8', path: '/bill-payment?type=electricity', active: true },
  { id: 'fastag', name: 'FASTAG RECHARGE', icon: Car, color: '#ef4444', bg: '#fef2f2', path: '/bill-payment?type=fastag', active: true },
  { id: 'loan', name: 'LOAN PAYMENT', icon: Banknote, color: '#14b8a6', bg: '#f0fdfa', path: '/bill-payment?type=loan', active: true },
  { id: 'lpg', name: 'LPG CYLINDER', icon: Flame, color: '#f97316', bg: '#fff7ed', path: null, active: false },
  { id: 'gas', name: 'GAS PIPELINE BILL', icon: Wind, color: '#06b6d4', bg: '#ecfeff', path: '/bill-payment?type=gas', active: true },
  { id: 'insurance', name: 'INSURANCE', icon: Shield, color: '#22c55e', bg: '#f0fdf4', path: null, active: false },
  { id: 'google', name: 'GOOGLE PLAY', icon: Gamepad2, color: '#3b82f6', bg: '#eff6ff', path: '/recharge?type=google_play', active: true },
  { id: 'pan', name: 'NSDL PAN CARD', icon: FileText, color: '#a855f7', bg: '#faf5ff', path: null, active: false },
  { id: 'lic', name: 'LIC BILL PAYMENT', icon: Heart, color: '#ec4899', bg: '#fdf2f8', path: null, active: false },
];

export default function Services() {
  const navigate = useNavigate();
  const [search, setSearch] = useState('');

  const filtered = SERVICES.filter(s =>
    s.name.toLowerCase().includes(search.toLowerCase())
  );

  return (
    <DashboardLayout>
      <div className="space-y-6" data-testid="services-page">
        {/* Breadcrumb */}
        <div className="flex items-center gap-2 text-sm text-slate-500">
          <Home className="w-4 h-4" />
          <ChevronRight className="w-3 h-3" />
          <span className="font-medium text-slate-700">Services</span>
        </div>

        {/* Header */}
        <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
          <div>
            <h1 className="text-2xl font-bold text-slate-900">My Services</h1>
            <p className="text-sm text-slate-500 mt-1">Choose a service to get started</p>
          </div>
          <div className="relative w-full sm:w-72">
            <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-slate-400" />
            <Input
              placeholder="Search..."
              value={search}
              onChange={e => setSearch(e.target.value)}
              className="pl-10 bg-white border-slate-200 rounded-xl h-10"
              data-testid="service-search"
            />
          </div>
        </div>

        {/* Service Grid */}
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 xl:grid-cols-6 gap-4">
          {filtered.map((service) => {
            const Icon = service.icon;
            return (
              <div
                key={service.id}
                className={`group relative bg-white rounded-2xl border border-slate-100 p-5 flex flex-col items-center text-center transition-all duration-300 hover:shadow-lg hover:shadow-slate-200/50 hover:-translate-y-1 ${
                  service.active ? 'cursor-pointer' : 'opacity-80'
                }`}
                onClick={() => service.active && navigate(service.path)}
                data-testid={`service-${service.id}`}
              >
                {/* Coming Soon Badge */}
                {!service.active && (
                  <div className="absolute top-2 right-2">
                    <Lock className="w-3.5 h-3.5 text-slate-300" />
                  </div>
                )}

                {/* Icon Circle */}
                <div
                  className="w-20 h-20 rounded-full flex items-center justify-center mb-4 transition-transform duration-300 group-hover:scale-110"
                  style={{
                    background: `linear-gradient(135deg, ${service.bg} 0%, white 100%)`,
                    border: `2px solid ${service.color}20`,
                  }}
                >
                  <Icon
                    className="w-9 h-9"
                    style={{ color: service.color }}
                    strokeWidth={1.5}
                  />
                </div>

                {/* Service Name */}
                <p className="text-[11px] font-bold text-slate-700 uppercase tracking-wide leading-tight mb-4 min-h-[28px] flex items-center">
                  {service.name}
                </p>

                {/* Button */}
                {service.active ? (
                  <button
                    className="px-5 py-1.5 rounded text-xs font-bold text-white transition-all duration-200 hover:brightness-110 active:scale-95"
                    style={{ backgroundColor: '#f97316' }}
                    data-testid={`service-btn-${service.id}`}
                  >
                    Get It
                  </button>
                ) : (
                  <span className="px-4 py-1.5 rounded text-[10px] font-semibold text-slate-400 bg-slate-50 border border-slate-100">
                    Coming Soon
                  </span>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </DashboardLayout>
  );
}
